<p-toast></p-toast>
<p-dialog
  *ngIf="displayModal"
  header="Invoice"
  [(visible)]="displayModal"
  [modal]="true"
  [style]="{ width: '50vw' }"
>
  <p class="p-m-0">
    <p-button
      icon="pi pi-check"
      (click)="print()"
      label="Print"
      styleClass="p-button-text"
    ></p-button>
  </p>

  <div *ngIf="success">
    <div class="spaces"></div>
    <app-invoicedetails class="notranslate"
      [data]="fetched"
      [dataId]="showInvoice"
    ></app-invoicedetails>
  </div>
</p-dialog>

<div *ngIf="success">
  <div class="spaces"></div>
  <app-invoicedetails class="notranslate"
    [data]="fetched"
    [dataId]="printContent"
  ></app-invoicedetails>
</div>

<div class="card no-margin">
  <div>
    <label style="margin: 2px; margin-right: 80px; vertical-align: super"
      ><b>Choose a Patient : </b>
    </label>
    <!-- <p-dropdown id="patient" placeholder=" Choose a patient" [options]="members" [style]="{'width': '270px'}" [(ngModel)]="memberValue" (ngModelChange)="onChange($event)" [ngModelOptions]="{standalone: true}" optionLable="name"></p-dropdown> -->
    <p-dropdown
      id="patient" class="notranslate"
      [options]="members"
      placeholder="Select"
      [(ngModel)]="memberValue"
      (ngModelChange)="onChange($event)"
      [ngModelOptions]="{ standalone: true }"
    ></p-dropdown>
  </div>
</div>
<div class="card no-margin" *ngIf="memberValue">
  <div class="mat-elevation-z8">
    <div
      class="table-responsive text-center justify-content-center"
      style="
        font-size: 14px;
        margin-bottom: 20px;
        text-align: center;
        vertical-align: center;
      "
    >
      <p-table
        #dt1
        [value]="Transactions"
        dataKey="id"
        styleClass="p-datatable-customers"
        [rows]="query.records_per_page"
        [paginator]="true"
        [scrollable]="true"
        [showCurrentPageReport]="true"
        (onLazyLoad)="getPatientTransactions($event)"
        [lazy]="true"
        [totalRecords]="total_records"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [rowsPerPageOptions]="[10, 25, 50]"
        [globalFilterFields]="[
          'SrNo',
          'date',
          'transactionType',
          'transactionNumber',
          'paidThrough',
          'amount'
        ]"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="SrNo" style="font-weight: bold">
              Sr No <p-sortIcon field="SrNo"> </p-sortIcon>
            </th>
            <th pSortableColumn="date" style="font-weight: bold">
              Date <p-sortIcon field="date"> </p-sortIcon>
            </th>
            <th pSortableColumn="status" style="font-weight: bold">
              Status <p-sortIcon field="status"> </p-sortIcon>
            </th>
            <th pSortableColumn="transactionType" style="font-weight: bold">
              Transaction Type <p-sortIcon field="transactionType"></p-sortIcon>
            </th>
            <th pSortableColumn="transactionNumber" style="font-weight: bold">
              Transaction No <p-sortIcon field="transactionNumber"></p-sortIcon>
            </th>
            <th pSortableColumn="paidThrough" style="font-weight: bold">
              Paid Through <p-sortIcon field="paidThrough"></p-sortIcon>
            </th>
            <th pSortableColumn="amount" style="font-weight: bold">
              Amount <p-sortIcon field="amount"> </p-sortIcon>
            </th>
            <th pSortableColumn="invoice" style="font-weight: bold">
              Invoice <p-sortIcon field="invoice"> </p-sortIcon>
            </th>
            <th pSortableColumn="invoice" style="font-weight: bold">
              Refund <p-sortIcon field="invoice"> </p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-transaction>
          <tr [pSelectableRow]="transaction">
            <td class="notranslate">
              {{ transaction.SrNo }}
            </td>
            <td>
              <span class="notranslate">{{ transaction.date | date: 'medium' }}</span>
            </td>
            <td>
              <span>{{ transaction.status }}</span>
            </td>
            <td>
              <span>{{ transaction.transactionType }}</span>
            </td>
            <td>
              <span class="notranslate">{{ transaction.transactionNumber }}</span>
            </td>
            <td>
              <span>{{
                transaction.amount ? transaction.paidThrough : 'None'
              }}</span>
            </td>
            <td>
              <span class="notranslate">{{ transaction.amount | currency: transaction.code }}</span>
            </td>
            <td>
              <span *ngIf="transaction.invoice_key != null">
                <p-button
                  (click)="getInvoiceBase64(transaction.invoice_url)"
                  icon="pi pi-download"
                  label="Download"
                ></p-button>
              </span>
              <span *ngIf="transaction.invoice_key == null"> N/A </span>
            </td>
            <td>
              <span
                *ngIf="
                  transaction.status == 'COMPLETE' &&
                    transaction.transactionType != 'Membership' &&
                    transaction.transactionType !=
                      'Multi Specialty Consultation' &&
                    !transaction.isDietConsultation &&
                    transaction.isConsultationNotClosed &&
                    !transaction.is_package;
                  else not_availaible
                "
              >
                <p-button
                  (click)="openRefundDialog(transaction.transaction_id)"
                  icon="pi pi-external-link"
                  label="Refund"
                ></p-button>
              </span>
              <ng-template #not_availaible> N/A </ng-template>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="8">No Transactions found.</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="paginatorleft"> </ng-template>
        <ng-template pTemplate="paginatorright"> </ng-template>
      </p-table>
    </div>
  </div>
  <div style="text-align-last: right">
    <p-button
      type="button"
      [style]="{
        'margin-right': '5px',
        'margin-top': '3px',
        'background-color': 'white',
        color: '#004AAD',
        'border-radius': '5px'
      }"
      [routerLink]="['/', this.slug, 'patient']"
      label="Back"
      class="p-button-lg"
      icon="pi pi-arrow-left"
    ></p-button>
  </div>
</div>

<p-dialog
  header="Submit a refund request"
  *ngIf="refundBool"
  [(visible)]="refundBool"
  (onHide)="openRefundDialog(null)"
  [modal]="true"
  [style]="{ width: '525px' }"
>
  <form
    *ngIf="!shouldShowOnSuccess"
    accept-charset="UTF-8"
    #refundForm="ngForm"
    (ngSubmit)="submitRefind()"
  >
    <h4>Reason for Refund</h4>
    <textarea
      rows="5"
      cols="30"
      maxlength="1000"
      name="reason"
      #reason="ngModel"
      placeholder="Enter the reasons"
      [(ngModel)]="body.refund_reason"
      required
      pInputTextarea
    ></textarea>
    <div
      *ngIf="reason.invalid && (reason.dirty || reason.touched)"
      class="alert alert-danger"
    >
      <div *ngIf="reason.errors.required" class="invalid">
        Refund reason is required
      </div>
    </div>
    <br />
    <br />
    <button
      type="submit"
      pButton
      label="Submit"
      icon="pi pi-check"
      [disabled]="!refundForm.valid || refresh"
    ></button>
    <p-progressSpinner
      [style]="{ width: '50px', height: '50px' }"
      *ngIf="refresh"
      strokeWidth="6"
    >
    </p-progressSpinner>
    <div
      class="row container justify-content-center text-center alert alert-danger"
      *ngIf="result.success != null && result.success == false"
    >
      <p *ngIf="result.error != null">{{ result.error.message }}</p>
      <div *ngIf="serverError?.error != null && serverError?.statusCode != 500">
        <p *ngFor="let message of serverError?.message">{{ message }}</p>
      </div>
      <div *ngIf="serverError?.error != null && serverError?.statusCode == 500">
        <p>{{ serverError?.message }}</p>
      </div>
    </div>
  </form>
  <div>
    <h4>{{ refund_message }}</h4>
  </div>
</p-dialog>
